import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        login : "",
        content : {
            _id:null,
            startDate : "",
            emdDate : "",
            title : [{key:"th", value:""},{key:"en", value:""}],
            subTitle : [{key:"th", value:""},{key:"en", value:""}],
            description : [{key:"th", value:""},{key:"en", value:""}],

            message : ""
        },
        item : []
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },
        content(state, obj) {
            state.content = obj;
        }
    },

    actions: {
        configLogin({commit}, data) {
            Service.login('get', {}, {})
                .then((response) => {
                    store.commit("config/item", response.data.data)
                }).catch((err) => {
            });
        },
        createLogin({commit}, data) {
            Service.login('post', data, {})
                .then((response) => {
                    store.dispatch("config/configLogin")
                }).catch((err) => {
            });
        },
        updateLogin({commit}, data) {
            Service.login('put', data, {})
                .then((response) => {
                    store.dispatch("config/configLogin")
                }).catch((err) => {
            });
        }

    },

    getters: {
        item(state, obj) {
            return state.item;
        },
        content(state, obj) {
            return state.content;
        }
    },
};

export default ServerModule;
